import { Component, Input, OnInit } from '@angular/core'
import { AbstractControl, FormGroup } from '@angular/forms'

@Component({
  selector: 'app-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.component.scss']
})
export class ValidationComponent {
  @Input() field: string
  @Input() form: FormGroup
  @Input() error: {
    required?: string
    max?: string
    min?: string
    pattern?: string
    maxLength?: string
    minLength?: string
    invalid?: string
    email?: string
    invalidDob?: string
    futureDate?: string
    countryCodeInvalid?: string
  }

  get f() {
    return this.form.controls
  }

  getControl(controlPath: string): AbstractControl | null {
    const control = this.form.get(controlPath)
    return control || null
  }
}
